import { ANALYTICS_OPENING_HEADER, staffAnalyticsEventDetailSchema, staffAnalyticsEventPageSchema, staffAnalyticsEventSummarySchema, staffAnalyticsRecentVisitsSchema, staffAnalyticsVisitDetailSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
function searchOf(query) {
    const search = new URLSearchParams();
    if (query === undefined)
        return search;
    for (const [key, value] of Object.entries(query)) {
        if (value !== undefined)
            search.set(key, String(value));
    }
    return search;
}
export function createStaffAnalyticsEventsApi(options) {
    const send = createMemoryTransport(options);
    const base = (customerId) => `/staff/analytics/customers/${encodeURIComponent(customerId)}`;
    const headers = (openingId) => ({ [ANALYTICS_OPENING_HEADER]: openingId });
    return {
        events: (customerId, openingId, query, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/events`,
            query: searchOf(query),
            headers: headers(openingId),
            schema: staffAnalyticsEventPageSchema,
            signal: callOptions?.signal,
        }),
        eventSummary: (customerId, openingId, query, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/events/summary`,
            query: searchOf(query),
            headers: headers(openingId),
            schema: staffAnalyticsEventSummarySchema,
            signal: callOptions?.signal,
        }),
        event: (customerId, openingId, eventUuid, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/events/${encodeURIComponent(eventUuid)}`,
            headers: headers(openingId),
            schema: staffAnalyticsEventDetailSchema,
            signal: callOptions?.signal,
        }),
        visit: (customerId, openingId, visitId, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/visits/${encodeURIComponent(visitId)}`,
            headers: headers(openingId),
            schema: staffAnalyticsVisitDetailSchema,
            signal: callOptions?.signal,
        }),
        recentVisits: (customerId, openingId, query, callOptions) => send({
            method: "GET",
            path: `${base(customerId)}/recent-visits`,
            query: searchOf(query),
            headers: headers(openingId),
            schema: staffAnalyticsRecentVisitsSchema,
            signal: callOptions?.signal,
        }),
    };
}
